module.exports = "https://store.zigzag.kr/resources/arm64/20260323-0901-2b8be06cb3_store/_next/static/images/MedalVip-70c82bf8a20d9dddc5ddf2bb049a43eb.png";